import { render, staticRenderFns } from "./DistributionActivationWizardBookingLicenceForm.vue?vue&type=template&id=848600b6&scoped=true&v-if=licence&"
import script from "./DistributionActivationWizardBookingLicenceForm.vue?vue&type=script&lang=js&"
export * from "./DistributionActivationWizardBookingLicenceForm.vue?vue&type=script&lang=js&"
import style0 from "./DistributionActivationWizardBookingLicenceForm.vue?vue&type=style&index=0&id=848600b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848600b6",
  null
  
)

export default component.exports